import type { MRT_Row, MRT_TableInstance } from "mantine-react-table-open";
import type {
  OnboardingTodo,
  SiteOverviewSite,
  SiteStatusSite
} from "../../site-status-types";
import { getAssessmentString } from "../columns/DataAssessmentCell";
import { calculateNumDoneOnboardingTodos } from "./calculateNumDoneOnboardingTodos";

function collectDataForExport(
  mrtTable: MRT_TableInstance<SiteStatusSite | SiteOverviewSite>
): Array<Array<string>> {
  const columnIdsForExport = mrtTable
    .getAllColumns()
    .filter((col) => !col.id?.includes("mrt-"))
    .map((col) => col.id);

  return Object.values(mrtTable.getRowModel().rowsById).map((row) =>
    columnIdsForExport.map((id) => valueFormatter(id, row))
  );
}

function valueFormatter(
  id: string,
  row: MRT_Row<SiteOverviewSite | SiteStatusSite>
): string {
  switch (id) {
    case "onboardingTodos": {
      return onboardingTodosFormatter(
        row.getValue<Array<OnboardingTodo>>("onboardingTodos")
      );
    }

    case "siteDataAssessmentGridMakoMeter": {
      const assessment = row.getValue<
        SiteOverviewSite["siteDataAssessment"]["gridMeterSufficient"]
      >("siteDataAssessmentGridMakoMeter");
      return getAssessmentString(assessment);
    }

    case "siteDataAssessmentGeneratorSubMeter": {
      const assessment = row.getValue<
        SiteOverviewSite["siteDataAssessment"]["subMeterDataIsSufficient"]
      >("siteDataAssessmentGridMakoMeter");
      return getAssessmentString(assessment);
    }

    case "meteringConceptRequirementsMet": {
      return row.getValue(id) ? "Erledigt" : "Nicht erledigt";
    }

    case "siteLabels": {
      return row
        .getValue<SiteStatusSite["siteLabels"]>(id)
        .map((siteLabel) => siteLabel.name)
        .join(", ");
    }

    default:
      return row.getValue(id);
  }
}

function onboardingTodosFormatter(todos: Array<OnboardingTodo>): string {
  if (todos.length === 0) {
    return "";
  }
  const numDone = calculateNumDoneOnboardingTodos(todos);
  if (numDone === todos.length) {
    return "Erledigt";
  } else if (numDone > 0) {
    return "Teilweise erledigt";
  } else {
    return "Nicht erledigt";
  }
}

export { collectDataForExport };
